/* eslint-disable */

// react imports
import React, { useState, useEffect } from "react";

// // react-router components
import { useNavigate } from "react-router-dom";

// @mui material components
import { Tooltip, Checkbox } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import MDButton from "components/MDButton";
import Link from "@mui/material/Link";

// context imports
import {
  useMaterialUIController,
  setUpdate,
  setOrderPage,
  setOrderPageEmpty,
  setStatusPageEmpty,
  setCanEdit,
  setEditID,
} from "context";

// firebase imports
import { getDocs, collection, query, orderBy } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { db, auth } from "../../../../../Firebase";
import { AdfScanner } from "@mui/icons-material";

export default function data() {
  // const [menu, setMenu] = useState(null);
  const [user] = useAuthState(auth);
  const navigate = useNavigate();
  const [controller, dispatch] = useMaterialUIController();
  const { currentStudy } = controller;

  const [rowArray, setRowArray] = useState([]);
  const [XLSXArray, setXLSXArray] = useState([]);
  const [customizationArray, setCustomizationArray] = useState([]);

  const [chosenForExport, setChosenForExport] = useState([]);

  useEffect(() => {
    // console.log("CHOSEN >>>", chosenForExport);
  }, [chosenForExport]);

  useEffect(() => {
    const customizations = chosenForExport
      .filter((el) => el.customization.customized === true)
      .map((item) => ({
        siteNumb: item.storeData.siteNumb,
        line1: item.customization.clinicName,
        line2: item.customization.line2,
        line3: item.customization.line3,
        orderId: item.orderId,
        street: `${item.shippingAddress.addressLine1}
${item.shippingAddress.addressLine2 === undefined ? "" : item.shippingAddress.addressLine2}
${item.shippingAddress.addressLine3 === undefined ? "" : item.shippingAddress.addressLine3}`,
        city: item.shippingAddress.city,
        state: item.shippingAddress.state,
        zip: item.shippingAddress.zip,
      }));
    console.log(customizations);
    setCustomizationArray(customizations);
  }, [chosenForExport]);

  useEffect(() => {
    const setXLSXData = async () => {
      // const orderDocs = collection(db, `${currentStudy}_ORDERS`);

      // const q = query(orderDocs, orderBy("date_created", "desc"));

      // const newDoc = await getDocs(q);
      // const parsedDocs = newDoc.docs.map((el) => ({ ...el.data(), id: el.id }));

      const dataArray = [];
      // const customizationArray = [];

      const itemArray = chosenForExport.map((el) => el.items).flat();

      // Sites
      const uniqueSites = chosenForExport.map((el) => el.storeData.siteNumb);

      const uniqueSitesCount = new Set(uniqueSites).size;

      const itemIds = itemArray.map((el) => el.id);

      const uniqueItemIds = new Set(itemIds);

      for (const element of uniqueItemIds) {
        const itemFilter = itemArray.filter((el) => el.id === element);
        const quantitySum = itemFilter.map((x) => x.cartQuantity);
        const itemQuantitySum = quantitySum.reduce((pv, cv) => pv + cv, 0);
        const itemConcat = { ...itemFilter[0], cartQuantity: itemQuantitySum };

        if (itemConcat.meta.length > 1) {
          for (const metaData of itemConcat.meta) {
            const newItemLine = {
              toolName: `${itemConcat.title} - ${metaData.title}`,
              desc: metaData.desc.replace(/, /g, ",\n"),
              sites: uniqueSitesCount,
              perSite: itemConcat.quantityOptions[0],
              qty: itemQuantitySum,
              perUnit: 0,
              total: 0,
            };
            dataArray.push(newItemLine);
          }
        } else {
          const newItemLine = {
            toolName: `${itemConcat.title} - ${itemConcat.meta[0].title}`,
            desc: `${itemConcat.meta[0].desc.replace(/, /g, ",\n")}`,
            sites: uniqueSitesCount,
            perSite: itemConcat.quantityOptions[0],
            qty: itemQuantitySum,
            perUnit: 0,
            total: 0,
          };
          dataArray.push(newItemLine);
        }
      }
      setXLSXArray(dataArray);
    };
    setXLSXData();
  }, [currentStudy, chosenForExport]);

  useEffect(() => {
    const avatars = (members) =>
      members.map(([image, key]) => (
        <Tooltip key={key} title={key} placeholder="bottom">
          <MDAvatar
            src={image}
            alt="name"
            size="md"
            variant="square"
            sx={{
              border: ({ borders: { borderWidth }, palette: { white } }) =>
                `${borderWidth[2]} solid ${white.main}`,
              cursor: "pointer",
              position: "relative",

              "&:not(:first-of-type)": {
                ml: { xs: 0, sm: -1.25 },
              },

              "&:hover, &:focus": {
                zIndex: "10",
              },
            }}
          />
        </Tooltip>
      ));

    const itemList = (items) =>
      items.map(([key, title, quantity]) => (
        <div key={key}>
          {title}: {quantity}
        </div>
      ));

    const setNewDocument = async () => {
      if (user) {
        const orderDocs = collection(db, `${currentStudy}_ORDERS`);

        const q = query(orderDocs, orderBy("date_created", "desc"));
        const newDoc = await getDocs(q);
        const parsedDocs = newDoc.docs.map((el) => ({ ...el.data(), id: el.id }));

        const newArray = [];

        for (const element of parsedDocs) {
          const itemArray = element.items.map((x) => [x.image, x.title]);
          const itemListArray = element.items.map((x) => [x.title, x.title, x.cartQuantity]);
          const elementArray = {
            export: (
              <Checkbox
                onChange={(e) => {
                  if (e.target.checked === true) {
                    setChosenForExport((array) => [...array, element]);
                  } else if (e.target.checked === false) {
                    setChosenForExport((array) => array.filter((item) => item.id !== element.id));
                  }
                }}
              />
            ),
            companies: element.orderId,
            site: element.storeData.siteNumb,
            date: (
              <>
                <MDBox>
                  <MDTypography
                    variant="caption"
                    fontWeight="medium"
                    textAlign="left"
                  >
                    Created:
                  </MDTypography>
                  {" "}
                  <MDTypography variant="caption" color="text" fontWeight="medium" textAlign="left">
                    {element.date_created.toDate().toLocaleDateString("en-us", {
                      weekday: "long",
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </MDTypography>
                </MDBox>
                <MDBox>
                  <MDTypography
                    variant="caption"
                    fontWeight="medium"
                    textAlign="left"
                  >
                    Updated:
                  </MDTypography>
                  {" "}
                  <MDTypography
                    variant="caption"
                    color={element.statusColor}
                    fontWeight="medium"
                    textAlign="left"
                  >
                    {element.date_modified.toDate().toLocaleDateString("en-us", {
                      weekday: "long",
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </MDTypography>
                </MDBox>
              </>
            ),
            created: (
              <MDTypography variant="caption" color="text" fontWeight="medium" textAlign="left">
                {element.date_created.toDate().toLocaleDateString("en-us", {
                  weekday: "long",
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })}
              </MDTypography>
            ),
            modified: (
              <MDTypography
                variant="caption"
                color={element.statusColor}
                fontWeight="medium"
                textAlign="left"
              >
                {element.date_modified.toDate().toLocaleDateString("en-us", {
                  weekday: "long",
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })}
              </MDTypography>
            ),
            members: (
              <MDBox>
                <MDBox display="flex" py={1}>
                  {avatars(itemArray)}
                </MDBox>
                <MDBox display="flex" py={1}>
                  <MDTypography variant="caption" color="text" fontWeight="medium" textAlign="left">
                    {itemList(itemListArray)}
                  </MDTypography>
                </MDBox>
              </MDBox>
            ),
            budget: (
              <MDTypography variant="caption" color="text" fontWeight="medium" textAlign="left">
                Attn: {element.shippingAddress.attn}
                <br />
                {element.shippingAddress.addressLine1}
                <br />
                {element.shippingAddress.addressLine2 === "" ? (
                  ""
                ) : (
                  <>
                    {element.shippingAddress.addressLine2}
                    <br />
                  </>
                )}
                {element.shippingAddress.addressLine3 === "" ? (
                  ""
                ) : (
                  <>
                    {element.shippingAddress.addressLine3}
                    <br />
                  </>
                )}
                {element.shippingAddress.city}, {element.shippingAddress.state}
                <br />
                {element.shippingAddress.zip}
                <br />
                {element.shippingAddress.country}
              </MDTypography>
            ),
            clinic: element.shippingAddress.clinic,
            completion: (
              <MDBox width="8rem">
                <MDBadge
                  badgeContent={element.status}
                  color={element.statusColor}
                  size="lg"
                  onClick={() => {
                    setUpdate(dispatch, element);
                    setStatusPageEmpty(dispatch, false);
                    navigate("/update");
                  }}
                  sx={{ cursor: "pointer" }}
                  container
                />
              </MDBox>
            ),
            view: (
              <MDBox width="8rem">
                <MDButton
                  variant="outlined"
                  color="secondary"
                  size="small"
                  onClick={() => {
                    setOrderPage(dispatch, element);
                    setOrderPageEmpty(dispatch, false);
                    navigate("/orderpage");
                  }}
                >
                  view order
                </MDButton>
              </MDBox>
            ),
            edit: (
              <MDBox width="8rem">
                <MDButton
                  variant="outlined"
                  color="secondary"
                  size="small"
                  disabled={element.status !== "new order"}
                  onClick={() => {
                    setOrderPage(dispatch, element);
                    setEditID(dispatch, element.id);
                    setCanEdit(dispatch, true);
                    navigate("/edit");
                  }}
                >
                  edit order
                </MDButton>
              </MDBox>
            ),
            details: (
              <>
                <MDBox pt={2} pb={0.5} sx={{ transform: 'scale(0.925)', transformOrigin: 'left' }}>
                  <MDBox>
                    <MDButton
                      variant="outlined"
                      color="secondary"
                      size="small"
                      onClick={() => {
                        setOrderPage(dispatch, element);
                        setOrderPageEmpty(dispatch, false);
                        navigate("/orderpage");
                      }}
                    >
                      view order
                    </MDButton>
                    {" "}{" "}
                    <MDButton
                      variant="outlined"
                      color="secondary"
                      size="small"
                      disabled={element.status !== "new order"}
                      onClick={() => {
                        setOrderPage(dispatch, element);
                        setEditID(dispatch, element.id);
                        setCanEdit(dispatch, true);
                        navigate("/edit");
                      }}
                    >
                      edit order
                    </MDButton>
                  </MDBox>
                  {(element.statusTimeline && element.statusTimeline.length > 0) && <>
                    {[0].map((object, idx) => {
                      let tracking = {}
                      for (const item of element.statusTimeline){
                        if (item.tracking && item.tracking.numb){
                          const trackingProvider = item.tracking.name.toLowerCase();
                          if (trackingProvider === 'fedex'){
                            item.tracking.name = 'FedEx';
                            item.tracking.link = `https://www.fedex.com/fedextrack/?trknbr=${item.tracking.numb}`;
                          } else if (trackingProvider === 'dhl'){
                            item.tracking.name = 'DHL';
                            item.tracking.link = `https://www.dhl.com/us-en/home/tracking.html?tracking-id=${item.tracking.numb}`;
                          } else if (trackingProvider === 'usps'){
                            item.tracking.name = 'USPS';
                            item.tracking.link = `https://tools.usps.com/go/TrackConfirmAction?tRef=fullpage&tLc=2&text28777=&tLabels=${item.tracking.numb}%2C&tABt=false`;
                          }
                          tracking = { ...item.tracking }
                        }
                      }
                      return (<React.Fragment key={idx}>
                      <MDBox pt={1.5}>
                        {tracking.numb && <>
                          <strong>{tracking.name}:</strong>
                          {" "}
                          <span>{tracking.numb}</span>
                          <MDBox sx={{ textDecoration: "underline" }}>
                            <Link target="_blank" rel="noreferrer" href={tracking.link}>Track package</Link>
                          </MDBox>
                        </>}
                      </MDBox>
                    </React.Fragment>)
                  })}
                </>}
              </MDBox>
              </>
            ),
          };
          newArray.push(elementArray);
        }
        setRowArray(newArray);
      }
    };
    setNewDocument();
  }, [currentStudy]);

  return {
    columns: [
      { Header: "export", accessor: "export", width: "5%", align: "left" },
      { Header: "order #", accessor: "companies", width: "10%", align: "left" },
      { Header: "site ID", accessor: "site", width: "10%", align: "left" },
      { Header: "clinic name", accessor: "clinic", width: "25%", align: "left" },
      { Header: "order details", accessor: "details", width: "25%", align: "left" },
      // { Header: "items", accessor: "members", width: "20%", align: "left" },
      // { Header: "shipping info", accessor: "budget", width: "15%", align: "left" },
      { Header: "status", accessor: "completion", width: "10%", align: "left" },
      { Header: "date", accessor: "date", width: "15%", align: "left" },
    ],

    rows: rowArray,
    XLSX: XLSXArray,
    custom: customizationArray,
    chosen: chosenForExport,
  };
}
